module.exports = __webpack_public_path__ + "img/leica.1ca27d5c.png";